const colors = {
  communicationBlue: '#0078d4',
  sharePointTeal: '#03787C',
  teal: '#029394',
  white: '#ffffff',
  gray96: '#f4f4f4',
  gray92: '#eaeaea',
  gray84: '#d4d7d9',
  gray44: '#6d7072',
  gray19: '#33332d',
};

const fontWeights = {
  regular: 400,
  semibold: 600,
  bold: 700,
};

const shadows = {
  standard: '0px 8px 56px rgba(0, 0, 0, 0.06)',
};

const theme = {
  color: colors,
  font: {
    weight: fontWeights,
  },
  shadow: shadows,
};

export default theme;



// WEBPACK FOOTER //
// ./src/styles/theme.js